import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronRight } from 'lucide-react';

const FAQ = ({ items, title = 'Frequently Asked Questions' }) => {
  const [open, setOpen] = React.useState(0);
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-[#2C5F66] text-3xl md:text-4xl font-extrabold text-center mb-12">{title}</h2>
        <div className="space-y-4">
          {items.map((item, idx) => (
            <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === idx ? -1 : idx)}
                className="w-full flex items-center justify-between text-left px-6 py-5 hover:bg-[#F7F7F5] transition-colors"
              >
                <span className="text-[#2C5F66] font-semibold text-lg">{item.q}</span>
                <ChevronDown className={`text-[#D9A04A] flex-shrink-0 transition-transform ${open === idx ? 'rotate-180' : ''}`} size={20} />
              </button>
              {open === idx && (
                <div className="px-6 pb-5 text-gray-600 text-[15px] leading-relaxed">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
